import { FC, FormEvent } from 'react';

import { Link } from '@inertiajs/react';
import { useForm } from '@inertiajs/react';
import { clsx } from 'clsx';

import { Button } from '../../components/ui/Button';
import { CardContent, CardFooter } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Routes } from '../../models/routes';

type FormValues = {
    nickname: string;
    telegram_username: string;
    email: string;
    password: string;
    password_confirmation: string;
};

export const SignUpForm: FC = () => {
    const { data, setData, post, processing, errors } = useForm<FormValues>({
        nickname: '',
        telegram_username: '',
        email: '',
        password: '',
        password_confirmation: '',
    });

    function submit(e: FormEvent) {
        e.preventDefault();
        post(Routes.SignUp);
    }

    return (
        <form onSubmit={submit}>
            <CardContent className="grid gap-4">
                <div className="grid grid-cols-1 gap-4">
                    <div className="grid gap-2">
                        <label
                            className="text-sm leading-none font-medium"
                            htmlFor="nickname"
                        >
                            Нікнейм
                        </label>
                        <Input
                            id="nickname"
                            value={data.nickname}
                            className={clsx({
                                'border-red-600': errors.nickname,
                            })}
                            onChange={(e) =>
                                setData('nickname', e.target.value)
                            }
                        />
                        {errors.nickname && (
                            <p className="text-sm text-red-600">
                                {errors.nickname}
                            </p>
                        )}
                    </div>
                    <div className="grid gap-2">
                        <label
                            className="text-sm leading-none font-medium"
                            htmlFor="telegram"
                        >
                            Telegram
                        </label>
                        <Input
                            id="telegram"
                            placeholder="@telegram"
                            value={data.telegram_username}
                            className={clsx({
                                'border-red-600': errors.telegram_username,
                            })}
                            onChange={(e) =>
                                setData('telegram_username', e.target.value)
                            }
                        />
                        {errors.telegram_username && (
                            <p className="text-sm text-red-600">
                                {errors.telegram_username}
                            </p>
                        )}
                    </div>
                </div>
                <div className="grid gap-2">
                    <label
                        className="text-sm leading-none font-medium"
                        htmlFor="email"
                    >
                        Електронна пошта
                    </label>
                    <Input
                        id="email"
                        type="email"
                        placeholder="m@example.com"
                        autoCapitalize="none"
                        autoComplete="email"
                        autoCorrect="off"
                        value={data.email}
                        className={clsx({
                            'border-red-600': errors.email,
                        })}
                        onChange={(e) => setData('email', e.target.value)}
                    />
                    {errors.email && (
                        <p className="text-sm text-red-600">{errors.email}</p>
                    )}
                </div>
                <div className="grid gap-2">
                    <label
                        className="text-sm leading-none font-medium"
                        htmlFor="password"
                    >
                        Пароль
                    </label>
                    <Input
                        id="password"
                        type="password"
                        autoComplete="current-password"
                        className={clsx({
                            'border-red-600': errors.password,
                        })}
                        onChange={(e) => setData('password', e.target.value)}
                    />
                    {errors.password && (
                        <p className="text-sm text-red-600">
                            {errors.password}
                        </p>
                    )}
                </div>
                <div className="grid gap-2">
                    <label
                        className="text-sm leading-none font-medium"
                        htmlFor="confirm-password"
                    >
                        Підтвердіть пароль
                    </label>
                    <Input
                        id="confirm-password"
                        type="password"
                        autoComplete="current-password"
                        className={clsx({
                            'border-red-600': errors.password_confirmation,
                        })}
                        onChange={(e) =>
                            setData('password_confirmation', e.target.value)
                        }
                    />
                    {errors.password_confirmation && (
                        <p className="text-sm text-red-600">
                            {errors.password_confirmation}
                        </p>
                    )}
                </div>
            </CardContent>
            <CardFooter className="flex flex-col">
                <Button className="w-full" type="submit" disabled={processing}>
                    Створити обліковий запис
                </Button>

                <p className="mt-4 text-center text-sm text-muted-foreground">
                    Вже маєте обліковий запис?{' '}
                    <Link
                        href={Routes.SignIn}
                        className="text-primary hover:underline"
                    >
                        Увійти
                    </Link>
                </p>
                <p className="mt-2 text-center text-sm text-muted-foreground">
                    <Link
                        href={Routes.ForgotPassword}
                        className="text-primary hover:underline"
                    >
                        Забули пароль?
                    </Link>
                </p>
            </CardFooter>
        </form>
    );
};
